import React from "react";
import axios from "axios";
import ModalGate from "../ModalGate/ModalGate";

const AudioArticleSignUp = ({article}) => {

    const onSubmit = async (formValues) => {
        try {
            await axios.post("/api/audio-player", {
                formValues
            });
        } catch (error) {
            // The errors are caught in web server and logged to rollbar
        }
        const script = document.createElement("script");
        script.src = "./scripts/SpeechifyConfiguration.js";
        const speechifyRoot = document.querySelector("#speechify-root");
        speechifyRoot.appendChild(script);

        // Push datalayer event for tracking within Google Analytics (GTM)
        window.dataLayer.push({
            "event": "submitAudioPlayerFormSuccess",
            "gtmCustomClick": {
                "eventCategory": "Conversion"
            }
        });
    };

    const modalHeaderContent = () =>
        <>
            <p className="m-b-0 text-inverted bold">
                Want to listen to this article for FREE?
            </p>
            <p className="text-inverted">
                Complete the form below to unlock access to ALL audio articles.
            </p>
        </>;

    const buttonContent = (isSubmitting = true, dataAttribute = "") => {
        if (isSubmitting) {
            return <>
                <i
                    className="far fa-headphones"
                    aria-hidden="true"
                    data-attribute={dataAttribute}
                />
                <span data-attribute={dataAttribute}>LISTEN NOW</span>
            </>;
        } else {
            return <>
                <span>Register</span>
            </>;
        }
    };

    const gatedCtaContent =
        <><span id="gated-cta-text"> <u>Register</u> for free to listen to this article</span><div id="inline-player-container">
            <div id="speechify-btn-inline-play">
                <svg viewBox='0 0 24 24' height='24' width='24' aria-hidden='true' focusable='false' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 000-1.69L9.54 5.98A.998.998 0 008 6.82z'></path>
                </svg>
            </div>
            <div id="inline-player-main">
                <div id="inline-player-header">Listen with &#32; <a target='_blank' href='https://speechify.com/'>Speechify</a></div>
                <div id="seekbar-container">
                    <div className="timings-text">
                        0:00
                    </div>
                    <div id="seekbar-bar">
                        <div id="seekbar-thumb"></div>
                    </div>
                    <div className="timings-text">
                        {article && article.readingTimeEstimate ? article.readingTimeEstimate + ":00" : "5:00"}
                    </div>
                </div>
            </div>
            <a id="speechify-icon" target='_blank' href='https://speechify.com/'>
                <svg width='34' height='19' viewBox='0 0 34 19' xmlns='http://www.w3.org/2000/svg' fill='currentColor'>
                    <path fillRule='evenodd' clipRule='evenodd' d='M7.13085 6.43475L7.97166 5.34716C8.35281 4.85414 8.97964 4.6224 9.58737 4.74983C10.0579 4.84849 10.3599 5.31228 10.2618 5.78572C10.2537 5.8249 10.2429 5.86348 10.2296 5.90119C9.53109 7.87216 9.30873 9.17396 9.5625 9.80659C10.6072 8.55759 15.9444 0.413118 17.6313 0.0265105C18.1945 -0.102562 18.755 0.252173 18.8833 0.818834C18.9267 1.01055 18.9159 1.21067 18.852 1.3965C17.2581 6.03365 16.5832 8.8376 16.8275 9.80836C17.6693 8.61652 18.9197 7.01242 20.5787 4.99605C21.2018 4.23866 22.1959 3.89924 23.1485 4.11866C23.9861 4.31161 24.5097 5.15124 24.3179 5.99404C24.3166 5.99958 24.3154 6.00511 24.3141 6.01064C23.7368 8.42634 23.5228 9.83969 23.6722 10.2507C23.738 10.2002 23.8048 10.1485 23.8728 10.0954C24.6337 9.50119 25.5864 9.21161 26.547 9.28254L34 9.83284L29.0621 10.3978C27.6835 10.5555 26.421 11.2496 25.5442 12.3316L24.3626 13.7898C23.9757 14.2672 23.3813 14.5242 22.7708 14.478C22.1644 14.432 21.663 13.9844 21.5455 13.384C21.2568 11.9092 21.2106 10.1684 21.4069 8.16161C19.9241 10.3907 18.6376 13.5967 17.5473 17.7793C17.3599 18.4985 16.7139 19 15.975 19C15.2693 19 14.6913 18.436 14.6696 17.7263L14.3429 7.03113L11.1828 13.2973C10.8539 13.9494 10.1302 14.2974 9.41932 14.1453C8.6662 13.9841 8.04316 13.4545 7.75942 12.7343L7.40531 11.8354C6.90425 10.5636 5.77337 9.65224 4.43045 9.438C2.95363 9.2024 1.47681 8.96681 0 8.73121L3.28955 8.4971C4.80287 8.3894 6.19938 7.63963 7.13085 6.43475Z'></path>
                </svg>
            </a>
        </div></>;

    return (
        <ModalGate
            onSubmit = {onSubmit}
            dataAttribute = "play-audio-article"
            modalHeaderContent = {modalHeaderContent}
            buttonContent = {buttonContent}
            gatedCtaContent={gatedCtaContent}
            clickOpenModalEventName="clickOpenAudioPlayerModal"
            clickCloseModalEventName="clickCloseAudioPlayerModal"
        />
    );
};

export default AudioArticleSignUp;